module.exports = __webpack_public_path__ + "img/Pl2.78332d38.png";